import "../scss/main.scss";
import "../js/minasidor/minasidor.js";
import { handleInfoMessage } from "./behaviours/handleInfoMessage";
import { formTracking, handleFocusOnError, handleSubmitButton } from "./behaviours/formSubmitButton";
//#region Immediate Load
handleInfoMessage();
handleFocusOnError();
//submit button in Create account
handleSubmitButton();
formTracking();
//#endregion Immediate Load
